import React from 'react';
import s from '../../../../../components/CheckMarkIcon/CheckMarkIcon.css';
import { generateUniqueId } from '../../../../../helpers/CommonHelper';

const iconEye = (setClass, setAria) => {
  return (
    <svg
      className={setClass}
      aria-labelledby="title desc"
      role="img"
      id="Livello_1"
      version="1.1"
      viewBox="-0.709 -32.081 141.732 141.732"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="title">Eye Icon</title>
      <desc id="desc">{setAria}</desc>
      <g id="Livello_80">
        <path d="M89.668,38.786c0-10.773-8.731-19.512-19.51-19.512S50.646,28.01,50.646,38.786c0,10.774,8.732,19.511,19.512,19.511 C80.934,58.297,89.668,49.561,89.668,38.786 M128.352,38.727c-13.315,17.599-34.426,28.972-58.193,28.972   c-23.77,0-44.879-11.373-58.194-28.972C25.279,21.129,46.389,9.756,70.158,9.756C93.927,9.756,115.036,21.129,128.352,38.727    M140.314,38.76C125.666,15.478,99.725,0,70.158,0S14.648,15.478,0,38.76c14.648,23.312,40.591,38.81,70.158,38.81 S125.666,62.072,140.314,38.76" />
      </g>
      <g id="Livello_1_1_" />
    </svg>
  );
};

// const iconSolo = (setClass, setAria) => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       viewBox="0 0 75 73.6"
//       className={setClass}
//       aria-labelledby="title desc"
//       role="img"
//     >
//       <title id="title">Solo Travel Icon</title>
//       <desc id="desc">{setAria}</desc>
//       <g id="Layer_2" data-name="Layer 2">
//         <g id="Layer_1-2" data-name="Layer 1">
//           <path d="M37.5,43.4A20.7,20.7,0,1,1,58.2,22.7,20.68,20.68,0,0,1,37.5,43.4Z" />
//           <path d="M56.5,41.5a26.68,26.68,0,0,1-38,.1A35.55,35.55,0,0,0,2,71.6H73A35.6,35.6,0,0,0,56.5,41.5Z" />
//         </g>
//       </g>
//     </svg>
//   );
// };

const iconSolo = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 75 73.6"
      className={setClass}
      // aria-labelledby="title desc"
      role="img"
    >
      <title>Solo Travel Icon</title>
      <desc>{setAria}</desc>
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path d="M37.5,43.4A20.7,20.7,0,1,1,58.2,22.7,20.68,20.68,0,0,1,37.5,43.4Z" />
          <path d="M56.5,41.5a26.68,26.68,0,0,1-38,.1A35.55,35.55,0,0,0,2,71.6H73A35.6,35.6,0,0,0,56.5,41.5Z" />
        </g>
      </g>
    </svg>
  );
};

const iconGroup = (setClass, setAria) => {


  let uniqID = generateUniqueId(); 
  let titleId = "groupTravelTitle-" + uniqID; 
  let descId = "groupTravelDesc-" + uniqID; 



  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.47 78.62"
      className={setClass}
      aria-labelledby={`${titleId} ${descId}`}
      role="img"
    >
      <title id={titleId}>Group Travel Icon</title>
      <desc id={descId}>{setAria}</desc>
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <path d="M28.24,32.6A15.3,15.3,0,1,1,43.53,17.3,15.29,15.29,0,0,1,28.24,32.6Z" />
          <path d="M42.28,31.19a19.74,19.74,0,0,1-28.09.08A26.28,26.28,0,0,0,2,53.44H54.47A26.33,26.33,0,0,0,42.28,31.19Z" />
          <path d="M99.24,32.6a15.3,15.3,0,1,1,15.29-15.3A15.29,15.29,0,0,1,99.24,32.6Z" />
          <path d="M113.28,31.19a19.74,19.74,0,0,1-28.09.08A26.28,26.28,0,0,0,73,53.44h52.47A26.33,26.33,0,0,0,113.28,31.19Z" />
          <path d="M63.74,48.42a20.7,20.7,0,1,1,20.7-20.7A20.68,20.68,0,0,1,63.74,48.42Z" />
          <path d="M82.74,46.52a26.68,26.68,0,0,1-38,.1,35.55,35.55,0,0,0-16.5,30h71A35.6,35.6,0,0,0,82.74,46.52Z" />
        </g>
      </g>
    </svg>
  );
};

const iconAddHousing = (setClass, setAria) => {

  let uniqID = generateUniqueId(); 
  let titleId = "housingTitle-" + uniqID; 
  let descId = "housingDesc-" + uniqID; 
  let layerId = "housingLayer-" + uniqID; 
  let realEstateId = "housingRealEstate-" + uniqID; 



  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby={`${titleId} ${descId}`}
      role="img"
      viewBox="0 0 107.52 81.81"
    >
      <title id={titleId}>Housing</title>
      <desc id={descId}>{setAria}</desc>
      <g id={layerId} data-name="Layer 2">
        <g id={realEstateId} data-name="real estate">
          <path d="M97.57,81.81H10a1.43,1.43,0,0,1-1.42-1.43V36.94H1.43a1.43,1.43,0,0,1-1-2.43L33.78.43a1.38,1.38,0,0,1,1-.43H72.73a1.41,1.41,0,0,1,1,.43l33.37,34.08a1.43,1.43,0,0,1-1,2.43H99V80.38A1.42,1.42,0,0,1,97.57,81.81ZM89,79h7.18v-42H11.38V79H63.62V46.66a1.43,1.43,0,0,1,1.43-1.43H87.53A1.43,1.43,0,0,1,89,46.66Zm-22.48-.08H86.11V48.08H66.48ZM4.82,34.08H102.7L72.13,2.85H35.39ZM50.65,70.59H21.51a1.43,1.43,0,0,1-1.43-1.43v-22a1.43,1.43,0,0,1,1.43-1.42H50.65a1.42,1.42,0,0,1,1.42,1.42v22A1.42,1.42,0,0,1,50.65,70.59ZM37.5,67.74H49.22V59.37H37.5Zm-14.56,0H34.65V59.37H22.94ZM37.5,56.52H49.22V48.58H37.5Zm-14.56,0H34.65V48.58H22.94Z" />
        </g>
      </g>
    </svg>
  );
};

const iconAddTransportation = (setClass, setAria) => {

  let uniqID = generateUniqueId(); 
  let titleId = "transportationTitle-" + uniqID; 
  let descId = "transportationDesc-" + uniqID; 
  let layerId = "transportationLayer-" + uniqID; 
  let travelId = "transporationTravel-" + uniqID; 

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby={`${titleId} ${descId}`}
      role="img"
      viewBox="0 0 103.21 103.21"
    >
      <title id={titleId}>Transportation Detail</title>
      <desc id={descId}>{setAria}</desc>
      <g id={layerId} data-name="Layer 2">
        <g id={travelId}>
          <path d="M27.12,103.21a1.57,1.57,0,0,1-.37,0,1.43,1.43,0,0,1-1-1l-3.89-14.6-2.09-2.09-4.48,4.48a1.42,1.42,0,1,1-2-2l4.47-4.48-2.08-2.08-14.6-3.9a1.42,1.42,0,0,1-.64-2.38l3-3a11.24,11.24,0,0,1,8.08-3.26L24.39,69,45.24,45.75,5.53,6a1.39,1.39,0,0,1-.41-1.16,1.41,1.41,0,0,1,.65-1.05L8.53,2.06a13.09,13.09,0,0,1,13.82-.17L62.77,26.18,78.5,8.62l.06-.06a17.41,17.41,0,0,1,8.93-4.45c4-.73,7.32,0,9.45,2.16s2.89,5.48,2.16,9.45a17.5,17.5,0,0,1-4.46,8.93l0,.06L77,40.44l24.3,40.42a13.05,13.05,0,0,1-.18,13.81l-1.76,2.77a1.43,1.43,0,0,1-1,.65,1.41,1.41,0,0,1-1.17-.41L57.46,58,34.19,78.82l.24,12.84a11.2,11.2,0,0,1-3.25,8.08l-3.05,3.05A1.44,1.44,0,0,1,27.12,103.21ZM24.73,87.29,27.86,99l1.3-1.29a8.36,8.36,0,0,0,2.42-6l-.2-10.39-6.64,5.94ZM59.59,56.06,97.93,94.41l.81-1.27a10.23,10.23,0,0,0,.13-10.81l-24-39.95ZM21.78,83.44l1.4,1.41L92.65,22.61a14.77,14.77,0,0,0,3.64-7.41c.55-3,0-5.49-1.37-6.91S91,6.36,88,6.91a14.82,14.82,0,0,0-7.4,3.64L64.11,29v0l-38,42.43h0L18.36,80l1.4,1.4,11.9-11.9a1.42,1.42,0,0,1,2,0,1.44,1.44,0,0,1,0,2Zm-17.6-8.1,11.74,3.14v0l5.95-6.64-10.39-.19a8.31,8.31,0,0,0-6,2.42ZM8.8,5.28,47.15,43.62,60.83,28.35l-39.95-24a10.25,10.25,0,0,0-10.82.14ZM89.52,22.6a1.47,1.47,0,0,1-1-.41,1.44,1.44,0,0,1,0-2,6.23,6.23,0,0,0,1.61-3.4,3.48,3.48,0,0,0-.69-3c-1.41-1.41-4.8-.67-6.39.92a1.43,1.43,0,0,1-2-2c2.62-2.62,7.75-3.59,10.43-.91A6.2,6.2,0,0,1,93,17.18a9.17,9.17,0,0,1-2.42,5A1.45,1.45,0,0,1,89.52,22.6Z" />
        </g>
      </g>
    </svg>
  );
};

const iconAddActivity = (setClass, setAria) => {


  let uniqID = generateUniqueId(); 
  let titleId = "activityTitle-" + uniqID; 
  let descId = "activityDesc-" + uniqID; 
  let layerId = "activityLayer-" + uniqID; 
  let activityId = "activity-" + uniqID; 


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 92.69 113.79"
      className={setClass}
      aria-labelledby={`${titleId} ${descId}`}
      role="img"
    >
      <title id={titleId}>Activities Detail</title>
      <desc id={descId}>{setAria}</desc>
      <g id={layerId} data-name="Layer 2">
        <g id={activityId}>
          <path d="M70.71,113.79H21.78A12.77,12.77,0,0,1,9.29,103.61H7a7,7,0,0,1-6.95-7V74.58a7,7,0,0,1,7-7H9V45.23a6.93,6.93,0,0,1-4.48-6.47V19.43a6.92,6.92,0,0,1,6.92-6.92H17V10.29a5.61,5.61,0,0,1,5.61-5.61h9.94a5.61,5.61,0,0,1,5.61,5.61v2.22H53.44V5.61A5.62,5.62,0,0,1,59.05,0H69A5.62,5.62,0,0,1,74.6,5.61v6.9H81a6.92,6.92,0,0,1,6.91,6.92V38.76a6.93,6.93,0,0,1-4.47,6.47V67.62h2.27a7,7,0,0,1,7,7V96.65a7,7,0,0,1-7,7H83.21A12.79,12.79,0,0,1,70.71,113.79ZM12,102.54a9.92,9.92,0,0,0,9.79,8.39H70.71a9.92,9.92,0,0,0,9.91-9.9V45.68H52.55v2.94a6,6,0,0,1-6,6h-.61a6,6,0,0,1-6-6V45.68H11.88V68.4a1.42,1.42,0,0,1,.16.65v33.13A1.49,1.49,0,0,1,12,102.54Zm71.52-1.79h2.23a4.11,4.11,0,0,0,4.1-4.1V74.58a4.11,4.11,0,0,0-4.1-4.1H83.51ZM7,70.48a4.11,4.11,0,0,0-4.1,4.1V96.65a4.11,4.11,0,0,0,4.1,4.1H9V70.48ZM42.79,45v3.67a3.16,3.16,0,0,0,3.15,3.15h.61a3.15,3.15,0,0,0,3.15-3.15V45h-2v1.93a1.43,1.43,0,1,1-2.85,0V45Zm9.76-2.13H81a4.06,4.06,0,0,0,4.06-4.06V19.43A4.07,4.07,0,0,0,81,15.36H11.47A4.07,4.07,0,0,0,7.4,19.43V38.76a4.07,4.07,0,0,0,4.07,4.06H39.94V39.88a6,6,0,0,1,6-6h.61a6,6,0,0,1,6,6Zm-6.3-.72H49.7V39.88a3.15,3.15,0,0,0-3.15-3.15h-.61a3.16,3.16,0,0,0-3.15,3.15V42.1Zm10-29.59H71.74V5.61A2.76,2.76,0,0,0,69,2.85H59.05a2.77,2.77,0,0,0-2.76,2.76Zm-36.4,0H35.34V10.29a2.77,2.77,0,0,0-2.76-2.76H22.64a2.76,2.76,0,0,0-2.75,2.76Zm41.57,96.18H31a7.42,7.42,0,0,1-7.41-7.41V72.73A8.35,8.35,0,0,1,32,64.39H60.54a8.35,8.35,0,0,1,8.34,8.34v28.55A7.43,7.43,0,0,1,61.46,108.69Zm-35-25.82v18.41A4.57,4.57,0,0,0,31,105.84H61.46A4.56,4.56,0,0,0,66,101.28V82.87Zm0-2.85H66V72.73a5.48,5.48,0,0,0-5.48-5.48H32a5.48,5.48,0,0,0-5.48,5.48Z" />
        </g>
      </g>
    </svg>
  );
};

const iconTableView = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 59 43.49"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Table View Icon</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M55.5,0H3.5A3.34,3.34,0,0,0,0,3.13V40.35a3.33,3.33,0,0,0,3.5,3.13h52A3.33,3.33,0,0,0,59,40.35V3.13A3.34,3.34,0,0,0,55.5,0ZM21,28.44V19.61H38v8.83Zm17,3v9H21v-9Zm0-23.7v8.83H21V7.74Zm18,0v8.83H41V7.74ZM18,16.57H3V7.74H18Zm-15,3H18v8.87H3Zm38,0H56v8.87H41ZM3.5,3h52a1.24,1.24,0,0,1,.5.13V4.74H3V3.19A.66.66,0,0,1,3.5,3ZM3,40.35H3V31.44H18v9H3.5A1.08,1.08,0,0,1,3,40.35Zm52.5.13H41v-9H56v8.85A.61.61,0,0,1,55.5,40.48Z" />
        </g>
      </g>
    </svg>
  );
};

const iconRosterView = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 84.9 37.35"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">People Roster View Icon</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M6.83,0a6.84,6.84,0,1,0,6.84,6.83A6.83,6.83,0,0,0,6.83,0Zm0,11.57a4.75,4.75,0,1,1,4.75-4.75A4.75,4.75,0,0,1,6.83,11.57Z" />
          <rect x="20.71" y="5.79" width="64.19" height="2.08" />
          <path d="M6.83,23.69a6.83,6.83,0,1,0,6.84,6.83A6.83,6.83,0,0,0,6.83,23.69Zm0,11.58a4.75,4.75,0,1,1,4.75-4.75A4.75,4.75,0,0,1,6.83,35.27Z" />
          <rect x="20.71" y="29.48" width="64.19" height="2.08" />
        </g>
      </g>
    </svg>
  );
};

const iconMap = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 69.07 56.08"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Map Icon</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M13.11,21.37l8.61,8.74,12.75-8.74L47.58,30l1.18-1.06,2,3.77-.71.95,3.19,16.76,10-5.07-3.89-7.8,2.36-4.84,7.32,14.53L51.83,56.08,34.36,47.46,17.12,56.08,0,47.46ZM56.79,0A11.21,11.21,0,0,1,66.94,15.82L56.79,36.25,47.11,16.88A11.18,11.18,0,0,1,56.79,0Zm0,4.6a6.85,6.85,0,1,1-6.85,6.85A6.85,6.85,0,0,1,56.79,4.6Zm-11,29.76-8.74-6.14V43.57l11.69,5.78Zm-22.2,0,8.86-6.14V43.57L20.78,49.35ZM14.4,29,19,33.65,15.94,50.3l-9.8-5Z" />
        </g>
      </g>
    </svg>
  );
};

const iconTrash = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95 94.5"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Trash_Blue</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M61.1,74.7h.1a2.16,2.16,0,0,0,2.1-2l2.4-38.6a2,2,0,0,0-2-2.2,2.11,2.11,0,0,0-2.2,2L59.1,72.5A2.11,2.11,0,0,0,61.1,74.7Z" />
          <path d="M47.5,74.7a2.05,2.05,0,0,0,2.1-2.1V34a2.1,2.1,0,0,0-4.2,0V72.6A2.05,2.05,0,0,0,47.5,74.7Z" />
          <path d="M33.8,74.7h.1a2.18,2.18,0,0,0,2-2.2L33.5,33.9a2.1,2.1,0,0,0-4.2.2l2.4,38.6A2.09,2.09,0,0,0,33.8,74.7Z" />
          <path d="M92.9,12.2H62.4V2.1A2.05,2.05,0,0,0,60.3,0H34.7a2.05,2.05,0,0,0-2.1,2.1V12.2H2.1a2.1,2.1,0,1,0,0,4.2H9.5l5.4,69.7a9.13,9.13,0,0,0,9,8.4H71a9.05,9.05,0,0,0,9-8.4l5.5-69.7h7.4a2.1,2.1,0,0,0,0-4.2Zm-56.1-8H58.2v8H36.8ZM75.9,85.7a4.88,4.88,0,0,1-4.8,4.5H23.9a4.81,4.81,0,0,1-4.8-4.5L13.8,16.4H81.3Z" />
        </g>
      </g>
    </svg>
  );
};

const iconCheckMark = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 94 94"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Checkmark</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="none"
            stroke="#043544"
            strokeWidth="4px"
            d="M47,2A45,45,0,1,0,92,47,45,45,0,0,0,47,2ZM73.27,34.81,42.46,64.69a2.69,2.69,0,0,1-3.79,0l-12-12a2.7,2.7,0,1,1,3.82-3.82L40.61,59l28.9-28a2.7,2.7,0,1,1,3.76,3.87Z"
          />
        </g>
      </g>
    </svg>
  );
};

const iconWarning = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98.12 78.71"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">No</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="none"
            stroke="#dc3849"
            strokeMiterlimit="12.5"
            strokeWidth="4px"
            d="M95,71.41,51.71,3.1a3.74,3.74,0,0,0-5.3,0L3.1,71.41a3.74,3.74,0,0,0,0,5.3H95A3.74,3.74,0,0,0,95,71.41ZM52.57,20.19l-1,35.11h-5l-1-35.11ZM49,70.19a4.53,4.53,0,0,1,.14-9,4.18,4.18,0,0,1,4.24,4.52A4.25,4.25,0,0,1,49,70.19Z"
          />
        </g>
      </g>
    </svg>
  );
};

const iconItinerary = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 4.25 3.9"
      className={setClass}
      aria-labelledby="itinerary-title itinerary-description"
      role="img"
      alt="Itinerary Icon"
    >
      <title id="itinerary-title">Itinerary Icon</title>
      <desc id="itinerary-description">{setAria}</desc>
      <g id="iconItineraryLayer_2" data-name="Layer 2">
        <g id="iconItineraryLayer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M.09,0H.83A.09.09,0,0,1,.92.09V.6A.11.11,0,0,1,.83.69H.09A.09.09,0,0,1,0,.6V.09A.08.08,0,0,1,.07,0ZM.74.19H.19V.5H.74Z"
          />
          <path
            className="cls-1"
            d="M.09,1.59H.83a.1.1,0,0,1,.09.1v.5a.09.09,0,0,1-.09.09H.09A.09.09,0,0,1,0,2.19v-.5a.08.08,0,0,1,.07-.1Zm.65.19H.19V2.1H.74Z"
          />
          <path
            className="cls-1"
            d="M.09,3.21H.83a.09.09,0,0,1,.09.1v.5s0,.08-.09.09H.09A.09.09,0,0,1,0,3.81v-.5a.08.08,0,0,1,.07-.1Zm.65.19H.19v.31H.74Z"
          />
          <path className="cls-1" d="M1.42.22a.12.12,0,0,0,0,.1s0,.09,0,.09H4.2s0,0,0-.07v0s0-.1,0-.1Z" />
          <path className="cls-1" d="M1.42,1.88a.12.12,0,0,0,0,.1s0,.09,0,.09H4.2s0,0,0-.07V2c0-.05,0-.1,0-.1Z" />
          <path className="cls-1" d="M1.42,3.46a.11.11,0,0,0,0,.09c0,.06,0,.1,0,.1H4.2s0,0,0-.07v0s0-.09,0-.09Z" />
        </g>
      </g>
    </svg>
  );
};

const iconCalendar = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 4.92 4.95"
      className={setClass}
      aria-labelledby="calendarTitle calendarDesc"
      role="img"
      alt="Calendar Icon"
    >
      <title id="calendarTitle">Calendar Icon</title>
      <desc id="calendarDesc">{setAria}</desc>
      <g id="calendarLayer_2" data-name="Layer 2">
        <g id="calendarLayer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M.34.38H4.58a.35.35,0,0,1,.24.1.37.37,0,0,1,.1.25V4.61A.34.34,0,0,1,4.58,5H.34a.35.35,0,0,1-.24-.1A.35.35,0,0,1,0,4.61V.73A.37.37,0,0,1,.1.48.35.35,0,0,1,.34.38ZM4.58.54H.34A.18.18,0,0,0,.21.6a.19.19,0,0,0,0,.13V4.61a.21.21,0,0,0,0,.13.21.21,0,0,0,.13,0H4.58a.17.17,0,0,0,.18-.18V.73a.19.19,0,0,0,0-.13A.18.18,0,0,0,4.58.54Z"
          />
          <path
            className="cls-1"
            d="M2.15,1.9h.63A.08.08,0,0,1,2.86,2v.43a.09.09,0,0,1-.08.08H2.15a.08.08,0,0,1-.08-.08V2A.07.07,0,0,1,2.15,1.9Zm.55.16H2.23v.27H2.7Z"
          />
          <path
            className="cls-1"
            d="M3.65,1.9h.63A.07.07,0,0,1,4.36,2v.43a.08.08,0,0,1-.08.08H3.65a.09.09,0,0,1-.08-.08V2A.08.08,0,0,1,3.65,1.9Zm.55.16H3.73v.27H4.2Z"
          />
          <path
            className="cls-1"
            d="M.64,2.92h.63A.08.08,0,0,1,1.35,3v.43a.09.09,0,0,1-.08.08H.64a.08.08,0,0,1-.08-.08V3A.07.07,0,0,1,.64,2.92Zm.55.16H.72v.27h.47Z"
          />
          <path
            className="cls-1"
            d="M2.15,2.92h.63A.08.08,0,0,1,2.86,3v.43a.09.09,0,0,1-.08.08H2.15a.08.08,0,0,1-.08-.08V3A.07.07,0,0,1,2.15,2.92Zm.55.16H2.23v.27H2.7Z"
          />
          <path
            className="cls-1"
            d="M3.65,2.92h.63A.07.07,0,0,1,4.36,3v.43a.08.08,0,0,1-.08.08H3.65a.09.09,0,0,1-.08-.08V3A.08.08,0,0,1,3.65,2.92Zm.55.16H3.73v.27H4.2Z"
          />
          <path
            className="cls-1"
            d="M.64,3.94h.63A.08.08,0,0,1,1.35,4v.43a.09.09,0,0,1-.08.08H.64a.08.08,0,0,1-.08-.08V4A.07.07,0,0,1,.64,3.94Zm.55.16H.72v.27h.47Z"
          />
          <path
            className="cls-1"
            d="M2.15,3.94h.63A.08.08,0,0,1,2.86,4v.43a.09.09,0,0,1-.08.08H2.15a.08.08,0,0,1-.08-.08V4A.07.07,0,0,1,2.15,3.94Zm.55.16H2.23v.27H2.7Z"
          />
          <path
            className="cls-1"
            d="M3.65,3.94h.63A.07.07,0,0,1,4.36,4v.43a.08.08,0,0,1-.08.08H3.65a.09.09,0,0,1-.08-.08V4A.08.08,0,0,1,3.65,3.94Zm.55.16H3.73v.27H4.2Z"
          />
          <path
            className="cls-1"
            d="M.08,1.47A.09.09,0,0,0,0,1.55a.08.08,0,0,0,.08.08H4.84a.07.07,0,0,0,.08-.08.08.08,0,0,0-.08-.08Z"
          />
          <path
            className="cls-1"
            d="M1,.08A.08.08,0,0,0,.93,0,.09.09,0,0,0,.85.08V.84A.08.08,0,0,0,.93.92.07.07,0,0,0,1,.84Z"
          />
          <path
            className="cls-1"
            d="M4.07.08A.09.09,0,0,0,4,0a.08.08,0,0,0-.08.08V.84A.07.07,0,0,0,4,.92.08.08,0,0,0,4.07.84Z"
          />
        </g>
      </g>
    </svg>
  );
};

const iconMapMagnifying = (setClass, setAria) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
      viewBox="0 0 612 792"
    >
      <title id="title">Magnify Map Icon</title>
      <desc id="desc">{setAria}</desc>

      <g>
        <path
          className="st0"
          d="M285.99,203.26c0,1.96,0,3.64,0,5.33c0,97.8,0.03,195.59-0.11,293.39c-0.01,4.49,1.35,6.33,5.54,7.88
        c31.99,11.79,63.86,23.89,95.76,35.9c1.42,0.53,2.9,0.98,4.22,1.71c4.17,2.28,6.11,6.95,4.78,11.19c-1.44,4.6-5.64,7.3-10.65,6.59
        c-1.81-0.25-3.58-0.94-5.31-1.59c-33.19-12.43-66.4-24.83-99.54-37.39c-3.09-1.17-5.59-1.07-8.63,0.08
        c-33.16,12.52-66.38,24.86-99.54,37.37c-4.54,1.72-8.67,1.73-13.22,0c-34.56-13.11-69.18-26.06-103.78-39.06
        c-8.07-3.03-9.43-4.93-9.43-13.42c-0.01-106.43,0.09-212.85-0.15-319.28c-0.02-10.77,7.05-14.66,16.19-11.13
        c33.07,12.74,66.31,25.06,99.56,37.33c2.52,0.93,5.98,0.99,8.49,0.06c33.25-12.27,66.43-24.74,99.57-37.29
        c4.53-1.72,8.69-1.81,13.24-0.09c34.72,13.15,69.49,26.18,104.24,39.25c7.86,2.96,9.32,5.05,9.32,13.5
        c0,14.21,0.02,28.43-0.01,42.64c-0.01,6.9-3.72,11.41-9.4,11.57c-5.83,0.16-9.77-4.5-9.79-11.67c-0.02-11.84,0.09-23.69-0.12-35.53
        c-0.03-1.56-1.27-4.01-2.54-4.5c-29.01-11.08-58.1-21.94-87.19-32.83C287.23,203.17,286.87,203.26,285.99,203.26z M175.69,541.85
        c2.25-0.79,3.79-1.3,5.31-1.87c26.85-10.08,53.66-20.26,80.58-30.15c3.91-1.44,5.31-3.17,5.31-7.46
        c-0.14-97.93-0.11-195.86-0.11-293.78c0-1.76,0-3.52,0-5.78c-2.32,0.82-3.9,1.36-5.45,1.94c-26.69,10.03-53.33,20.2-80.12,29.95
        c-4.54,1.65-5.62,3.83-5.61,8.35c0.13,97.59,0.1,195.18,0.1,292.77C175.69,537.62,175.69,539.43,175.69,541.85z M156.09,541.84
        c0.11-2.05,0.27-3.54,0.27-5.03c0.01-98.47-0.01-196.94,0.09-295.41c0-3.44-1.04-5.01-4.29-6.19c-18.39-6.7-36.7-13.65-55.03-20.52
        c-10.4-3.9-20.79-7.82-31.57-11.88c-0.09,2.04-0.21,3.52-0.21,5.01c-0.01,98.47,0.02,196.94-0.1,295.41c0,3.78,1.37,5.18,4.67,6.38
        c16.01,5.84,31.92,11.97,47.88,17.96C130.4,532.29,143.03,536.97,156.09,541.84z"
        />
        <path
          className="st0"
          d="M485.48,496.34c-46.62,36.94-107.9,27.92-142.09-11.18c-33.02-37.77-33-96.03,0.58-133.65
        c34.61-38.77,91.85-45.11,134.36-16.01c38.87,26.61,63.67,92.96,20.18,148.13c18.41,18.37,36.85,36.76,55.28,55.16
        c1.92,1.91,3.91,3.76,5.7,5.78c3.62,4.09,3.6,9.62,0.09,13.29c-3.72,3.89-9.25,3.97-13.65,0.15c-1.15-1-2.18-2.12-3.26-3.2
        c-17.95-17.94-35.91-35.87-53.82-53.86C487.55,499.65,486.64,497.95,485.48,496.34z M420.35,500.74
        c45.55-0.18,82.01-36.87,81.92-82.42c-0.09-45.36-37.26-81.75-83.32-81.56c-44.33,0.18-80.82,37.12-80.92,81.92
        C337.93,463.93,375.04,500.92,420.35,500.74z"
        />
      </g>
    </svg>
  );
};

const iconSuitcase = (setClass, setAria) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 612 792"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Suitcase Icon</title>
      <desc id="desc">{setAria}</desc>

      <g>
        <path
          className="st0"
          d="M214.8,213.61c0-13.17-0.75-22.29,0.14-31.26c2.76-27.79,19.29-45.23,47.38-46.96
     c27.16-1.67,54.54-1.7,81.73-0.43c34.83,1.63,49.47,18.33,50.55,54.1c0.21,7.09,0.64,14.18,1.11,24.54
     c40.85,0,80.53-0.09,120.21,0.02c48.22,0.13,73.79,25.25,73.99,73.93c0.36,88.14,0.38,176.29-0.01,264.43
     c-0.22,49.77-26.08,75.1-76.15,75.17c-139.03,0.18-278.06,0.17-417.1,0c-50.63-0.06-74.7-24.56-74.76-75.46
     c-0.09-88.14-0.12-176.29,0.01-264.43c0.07-49.89,23.62-73.53,72.99-73.64C133.81,213.54,172.72,213.61,214.8,213.61z
      M199.35,608.96c71.58,0,141.1,0,211.98,0c0-126.19,0-250.49,0-376.86c-72.51,0-142.73,0-211.98,0 M38.26,541.96
     c0.03,54.2,18.28,71.12,75.49,67.61c0-127.26,0-252.82,0-378.25c-59.1-4.11-75.48,11.09-75.49,68.44 M495.72,607.9
     c53.96,7.49,76.93-11.74,76.99-61.79c0.1-85.21,0.17-170.41-0.03-255.62c-0.11-48.57-28.91-69.49-76.97-56.02 M179.06,231.22
     c-16.09,0-30.28,0-45.23,0c0,126.77,0,252.29,0,378.71c15.42,0,28.88,0,45.23,0 M431.89,609.34c16,0,29.24,0,44.17,0
     c0-126.79,0-252.08,0-377.75c-16.24,0-30.31,0-44.17,0 M234.77,212.07c48.12,0,94.83,0,141.36,0c5.49-50.99-1.87-59.31-51.03-59.35
     c-13.6-0.01-27.19-0.01-40.79,0C236.9,152.76,229.86,160.77,234.77,212.07z"
        />
      </g>
    </svg>
  );
};

const iconGear = (setClass, setAria) => {
  return (
    <svg
      width="28px"
      height="28px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Gear Icon</title>
      <desc id="desc">{setAria}</desc>

      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="program-/-list-/-item" transform="translate(-887.000000, -31.000000)" fill="#007bff" fillRule="nonzero">
          <g id="settings" transform="translate(857.000000, 0.000000)">
            <path
              d="M56.2635044,42.3485008 L54.0169336,41.8496091 C53.8419307,41.2905145 53.6141936,40.7547544 53.3495892,40.239062 L54.5652761,38.2159608 C55.0193503,37.4902578 55.2470875,36.4238712 54.5652761,35.7401703 L53.3267221,34.5029751 C52.9930499,34.1678917 52.5441091,34.0269513 52.0919015,34.0269513 C51.6233604,34.0269513 51.1487525,34.1800257 50.7950133,34.4259713 L48.8242471,35.6809007 C48.3127719,35.4158208 47.7798297,35.1885428 47.2244871,35.0084004 L46.7204787,32.7360868 C46.5702095,31.9021118 45.8407973,31 44.8747812,31 L43.1247521,31 C42.1578026,31 41.5660594,31.9161125 41.3747229,32.7500875 L40.8123802,34.9953331 C40.220637,35.1838759 39.6503608,35.426088 39.1090185,35.7117023 L37.0901848,34.4269047 C36.7345789,34.180959 36.2618377,34.0278847 35.7914299,34.0278847 C35.3401557,34.0278847 34.8916815,34.1683584 34.5566093,34.5039085 L33.319922,35.7411037 C32.6362439,36.4248046 32.8658478,37.4911912 33.319922,38.2168942 L34.5976766,40.3468673 C34.3587393,40.8308249 34.1454691,41.3283164 33.9816664,41.8505425 L31.7364956,42.3494341 C30.9025484,42.4997083 30,43.2286781 30,44.1951931 L30,45.9452806 C30,46.9117956 30.9160819,47.5035585 31.7500292,47.6949014 L34.0232004,48.2628631 C34.1809363,48.7449539 34.3760063,49.2088438 34.5990767,49.6573329 L33.3194553,51.7901062 C32.8653811,52.5139424 32.6367106,53.580329 33.3194553,54.2640299 L34.5580093,55.5016918 C34.8916815,55.8363085 35.3401557,55.9781822 35.7923632,55.9781822 C36.2618377,55.9781822 36.7355123,55.8251079 37.0901848,55.5791623 L39.1136852,54.2882977 C39.658761,54.5771789 40.2318372,54.8217244 40.8282471,55.0102672 L41.3887231,57.2499125 C41.5800597,58.0838875 42.1718029,59 43.1387523,59 L44.8887815,59 C45.8547976,59 46.5842097,58.0974215 46.7344789,57.2634465 L47.2384873,54.9845992 C47.7882298,54.8067903 48.3160386,54.5827791 48.8205137,54.320966 L50.7950133,55.5786956 C51.1487525,55.8246412 51.6233604,55.9777156 52.0919015,55.9777156 C52.5450424,55.9777156 52.9935166,55.8353751 53.3267221,55.5012251 L54.5652761,54.2635632 C55.2470875,53.5798623 55.0193503,52.5134757 54.5652761,51.7896395 L53.3486558,49.7632715 C53.5927265,49.2811807 53.8055301,48.7813557 53.9758663,48.2619298 L56.2499708,47.693968 C57.0839181,47.5026251 58,46.9108622 58,45.9443472 L58,44.1942597 C58,43.2277447 57.0974516,42.4992416 56.2635044,42.3485008 Z M56.5999767,45.9443472 C56.5999767,46.013884 56.3409723,46.2355618 55.9106985,46.3368335 L53.6365939,46.9038619 L52.8866481,47.0914712 L52.6458441,47.8269747 C52.5035084,48.2591296 52.320572,48.6964182 52.1017017,49.1267063 L51.7488958,49.8174075 L52.1479025,50.4810407 L53.378523,52.5312099 C53.6001933,52.8849609 53.6239937,53.2237779 53.5763929,53.273247 L52.3350389,54.5118423 C52.2748379,54.5720453 52.1339022,54.5776455 52.0919015,54.5776455 C51.9196987,54.5776455 51.722762,54.5174425 51.5916265,54.4273714 L51.5696928,54.412904 L51.5468258,54.3975032 L49.5732596,53.1397737 L48.8923815,52.7048186 L48.1760363,53.0767705 C47.7266288,53.3110489 47.2655544,53.5033252 46.8072801,53.6507992 L46.0447341,53.8986116 L45.8725312,54.680784 L45.3666561,56.9596313 L45.3559226,57.014234 C45.3041217,57.3040485 45.0395173,57.5994633 44.8883148,57.5994633 L43.1382856,57.5994633 C43.0682845,57.5994633 42.8456808,57.3413837 42.7453458,56.9092288 L42.1867364,54.6695835 L41.9963333,53.9102788 L41.2496542,53.6741337 C40.7521792,53.5163925 40.2533042,53.3059153 39.7665628,53.0487691 L39.0474175,52.6702835 L38.3609393,53.1080387 L36.337439,54.3970365 L36.3136386,54.4124373 L36.2917049,54.4269047 C36.1605693,54.5169758 35.9636327,54.5771789 35.7914299,54.5771789 C35.7494292,54.5771789 35.6080268,54.5715786 35.5473591,54.5090421 L34.3097385,53.273247 C34.2607377,53.2242445 34.2840714,52.8849609 34.5192753,52.5074087 L35.7988966,50.3755688 L36.1937032,49.7194026 L35.8520975,49.0329016 C35.6462941,48.6180142 35.482958,48.2236612 35.3546226,47.8279081 L35.1138186,47.0914712 L34.362006,46.9038619 L32.0622344,46.3298332 C31.6566943,46.2360285 31.3995567,46.0143507 31.3995567,45.9448139 L31.3995567,44.1947264 C31.3995567,44.0430522 31.6930949,43.7789056 31.9828997,43.725703 L32.0118335,43.7215027 L32.0393673,43.7149691 L34.2845381,43.2174775 L35.0746179,43.0424688 L35.3163553,42.2714969 C35.4465574,41.8598763 35.6215604,41.4347217 35.8511642,40.9698985 L36.1927699,40.2833975 L35.79703,39.6258313 L34.5057418,37.4720569 C34.2840714,37.1192393 34.2598043,36.7790223 34.3088051,36.7300198 L35.5454924,35.4928246 C35.6056934,35.4326216 35.7368289,35.4270214 35.7904965,35.4270214 C35.9636327,35.4270214 36.159636,35.4848909 36.2907715,35.5744954 L36.3127052,35.5908295 L36.337439,35.6057636 L38.3562726,36.892428 L39.0418174,37.3287831 L39.7609627,36.9498308 C40.239304,36.6982849 40.7353789,36.4878077 41.238454,36.3291331 L41.9813997,36.0911212 L42.1708695,35.3336834 L42.7388123,33.0627698 C42.8316805,32.6567495 43.0561509,32.3996033 43.1242854,32.3996033 L44.8743146,32.3996033 C45.0255171,32.3996033 45.2901215,32.693618 45.3419224,32.9834325 L45.3475225,33.0119006 L45.3531226,33.0394353 L45.857131,35.3117489 L46.0312005,36.0934547 L46.7942132,36.339867 C47.259021,36.4901412 47.7247621,36.6870844 48.180703,36.9222961 L48.8970483,37.2937814 L49.5779263,36.860693 L51.5468258,35.6052969 L51.5696928,35.5903629 L51.5916265,35.5740287 C51.722762,35.4839575 51.9196987,35.4265547 52.0919015,35.4265547 C52.1348356,35.4265547 52.2753046,35.4307549 52.337839,35.492358 L53.5735929,36.7281531 C53.6239937,36.7771555 53.6001933,37.1192393 53.3649894,37.4935247 L52.1493025,39.5170925 L51.7502958,40.1844592 L52.1031017,40.8760938 C52.3509058,41.3600513 52.539909,41.8164742 52.6813114,42.2677634 L52.9235154,43.0415354 L53.7135952,43.2165442 L55.960166,43.7140357 L55.9876998,43.7224361 L56.0152336,43.7252363 C56.3045717,43.7789056 56.6004433,44.0425855 56.6004433,44.1942597 L56.6004433,45.9443472 L56.5999767,45.9443472 Z M44.0105002,39.3896862 C40.9159819,39.3896862 38.3968733,41.9042119 38.3968733,44.9950998 C38.3968733,48.086921 40.9159819,50.5986466 44.0105002,50.5986466 C47.1068851,50.5986466 49.6250604,48.0864543 49.6250604,44.9950998 C49.6255271,41.9042119 47.1068851,39.3896862 44.0105002,39.3896862 Z M44.0245004,49.2317116 C41.6901948,49.2317116 39.7898965,47.3374169 39.7898965,45.0105005 C39.7898965,42.6835842 41.6901948,40.7897562 44.0245004,40.7897562 C46.3578726,40.7897562 48.2572376,42.6835842 48.2572376,45.0105005 C48.2572376,47.3374169 46.3578726,49.2317116 44.0245004,49.2317116 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const iconClock = (setClass, setAria) => {

  let uniqID = generateUniqueId(); 
  let titleId = "clockIconTitle-" + uniqID; 
  let descId = "clockIconDesc-" + uniqID; 
  let layerId = "clockIconLayer-" + uniqID; 
  let layerId2 = "clockIconLayer2-" + uniqID; 


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 390.21 384.61"
      className={setClass}
      aria-labelledby={`${titleId} ${descId}`}
      role="img"
    >
      <title id={titleId}>Clock Icon</title>
      <desc id={descId}>{setAria}</desc>
      <g id={layerId} data-name="Layer 2">
        <g id={layerId2} data-name="Layer 1">
          <g>
            <path
              className="cls-1"
              d="M195,13.07C110.49,13.15,36.2,72.31,17.69,154.29c-19.28,85.43,23.54,171.3,103.48,207,8.91,4,18.44,6.58,27.68,9.8.81.29,1.68.42,2.5.69a6.57,6.57,0,0,1,4.6,8.13,6.64,6.64,0,0,1-8.18,4.47,189.2,189.2,0,0,1-54.4-22.72Q26.75,320.19,6.3,244.37C0,221.05-1.36,197.3,1.24,173.26,9.12,100.33,58.9,37.27,127.73,12A194.69,194.69,0,0,1,208,.4c78.82,4.92,147,58.3,171.9,132A193.8,193.8,0,0,1,389.63,210a191.12,191.12,0,0,1-12.32,54.73c-1.79,4.62-6.1,6.22-9.85,3.8-2.79-1.8-3.49-4.84-2.37-8.58,2.84-9.48,6-18.9,8.18-28.55a161.17,161.17,0,0,0,2-61c-10.72-67.41-47.66-115-109.63-143C243.75,17.5,219,13.05,195,13.07Z"
            />
            <path
              className="cls-1"
              d="M283.06,330.82l-21.32,42.57-42.37-115,115,42.37L291.39,322.3a23.13,23.13,0,0,1,3.45,2.27Q315,344.63,335,364.78a11.19,11.19,0,0,1,3,4.49,5.83,5.83,0,0,1-2.65,6.77,6.53,6.53,0,0,1-7.61-.13,17,17,0,0,1-2.37-2.21Q305.48,353.84,285.63,334C284.81,333.13,284.15,332.15,283.06,330.82ZM241.6,280.58l22,59.65c2.12-4.25,4.47-7.94,5.88-12,3.47-9.86,9.81-16.44,19.8-19.8,4.05-1.37,7.73-3.81,11.93-5.94Z"
            />
            <path
              className="cls-1"
              d="M168.69,187.85c3-4.26,5.58-8.85,9-12.68,2.14-2.36,5.42-3.91,8.46-5.16,2-.84,2.48-1.75,2.47-3.73q-.09-31.36,0-62.72c0-3.6,2.14-6.23,5.31-6.76a6.44,6.44,0,0,1,7.26,4.15,11.84,11.84,0,0,1,.41,3.82c0,20.47.06,41,0,61.42,0,2.22.66,3.11,2.71,3.88a25.85,25.85,0,0,1,16.78,27.43c-1.24,11.32-10.74,21-22.19,22.67a26,26,0,0,1-27.66-15.93c-.82-2-1.68-2.72-3.9-2.7-14.08.12-28.16.14-42.25,0a11.3,11.3,0,0,1-6.15-2.06c-2.16-1.6-2.39-4.29-1.35-6.81,1.21-2.91,3.54-4.19,6.67-4.19q19.67,0,39.32,0h5.84Zm26.23,19.42A13,13,0,1,0,182.12,194,13.24,13.24,0,0,0,194.92,207.27Z"
            />
            <path
              className="cls-1"
              d="M303.6,92.55c-1,2.1-1.36,3.65-2.27,4.75a45.11,45.11,0,0,1-5.48,5.49,6.5,6.5,0,0,1-9.17-9.16,53.69,53.69,0,0,1,5.49-5.49c2-1.79,4.69-2.34,6.88-.82C300.91,88.6,302.13,90.81,303.6,92.55Z"
            />
            <path
              className="cls-1"
              d="M93.37,85.84c2.06.94,3.6,1.31,4.71,2.22a45.92,45.92,0,0,1,5.51,5.47,6.43,6.43,0,0,1-.29,8.8,6.53,6.53,0,0,1-8.83.44A46.82,46.82,0,0,1,88.78,97c-1.72-2.07-2.16-4.73-.52-6.9C89.57,88.37,91.67,87.22,93.37,85.84Z"
            />
            <path
              className="cls-1"
              d="M105.86,290.28c-1,2.11-1.42,3.65-2.34,4.76a41.57,41.57,0,0,1-5.25,5.28,6.4,6.4,0,0,1-9.06-.34,6.3,6.3,0,0,1,0-9,58.7,58.7,0,0,1,5.06-5c2.14-1.88,4.86-2.49,7.17-.88C103.25,286.31,104.45,288.55,105.86,290.28Z"
            />
            <path
              className="cls-1"
              d="M201.61,54.54c0,1.3.08,2.6,0,3.88a6.31,6.31,0,0,1-6.51,5.83,6.24,6.24,0,0,1-6.44-5.89c-.13-2.47-.1-5,0-7.43a6.5,6.5,0,0,1,13,.06C201.67,52.17,201.62,53.36,201.61,54.54Z"
            />
            <path
              className="cls-1"
              d="M55.16,200.79c-1.19,0-2.38.05-3.56,0a6.5,6.5,0,0,1,0-13c2.37-.13,4.75-.1,7.12,0a6.35,6.35,0,0,1,6.36,6.67,6.28,6.28,0,0,1-6.36,6.32C57.53,200.83,56.35,200.79,55.16,200.79Z"
            />
            <path
              className="cls-1"
              d="M334.75,200.79c-1.18,0-2.37.05-3.55,0a6.5,6.5,0,0,1,0-13c2.36-.13,4.74-.1,7.11,0a6.35,6.35,0,0,1,6.37,6.66,6.28,6.28,0,0,1-6.35,6.33C337.12,200.83,335.94,200.79,334.75,200.79Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const iconClockPicker = (setClass, setAria) => {

  let uniqID = generateUniqueId(); 
  let titleId = "clockIconTitle-" + uniqID; 
  let descId = "clockIconDesc-" + uniqID; 

  return (
    <svg aria-label={`${titleId} ${descId}`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <title id={titleId}>Clock Icon</title>
      <desc id={descId}>{setAria}</desc>
      <path d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM8.14078 7.60969L13.0627 10.9378C13.3876 11.1718 13.6073 11.5243 13.6743 11.919C13.7413 12.3138 13.6502 12.719 13.4207 13.0471C13.1913 13.3752 12.8418 13.5998 12.4481 13.6723C12.0543 13.7447 11.6478 13.6593 11.3166 13.4344C11.171 13.3317 11.0442 13.2049 10.9416 13.0594L7.61344 8.1375C7.56221 8.06411 7.53844 7.97503 7.54631 7.88588C7.55417 7.79672 7.59316 7.71318 7.65645 7.64989C7.71974 7.5866 7.80328 7.54761 7.89244 7.53974C7.98159 7.53188 8.07067 7.55564 8.14406 7.60687L8.14078 7.60969ZM12 20.25C7.45312 20.25 3.75 16.5492 3.75 12C3.74614 10.8904 3.968 9.79163 4.4021 8.77048C4.83621 7.74933 5.47348 6.82714 6.27516 6.06C6.3375 5.99784 6.4116 5.94872 6.49312 5.9155C6.57465 5.88227 6.66197 5.86561 6.75 5.86648C6.83804 5.86735 6.92501 5.88574 7.00587 5.92057C7.08672 5.9554 7.15983 6.00598 7.22093 6.06935C7.28204 6.13273 7.32992 6.20764 7.36177 6.28971C7.39363 6.37178 7.40883 6.45937 7.40649 6.54737C7.40415 6.63538 7.38431 6.72203 7.34814 6.80229C7.31196 6.88255 7.26017 6.95481 7.19578 7.01484C6.52306 7.65874 5.98829 8.4327 5.62398 9.28969C5.25967 10.1467 5.07342 11.0688 5.07656 12C5.07656 15.8175 8.1825 18.9234 12 18.9234C15.8175 18.9234 18.9234 15.8175 18.9234 12C18.9234 8.40609 16.1709 5.44313 12.6633 5.10938V7.6875C12.6633 7.86341 12.5934 8.03212 12.469 8.15651C12.3446 8.2809 12.1759 8.35078 12 8.35078C11.8241 8.35078 11.6554 8.2809 11.531 8.15651C11.4066 8.03212 11.3367 7.86341 11.3367 7.6875V4.41328C11.3367 4.23737 11.4066 4.06866 11.531 3.94427C11.6554 3.81988 11.8241 3.75 12 3.75C16.5492 3.75 20.25 7.45312 20.25 12C20.25 16.5469 16.5492 20.25 12 20.25Z" fill="#446372"/>
    </svg>
  );
};

const iconPencil = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 159.28 166.44"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Pencil Icon</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M124.43,0c2.14,1.13,4.64,1.88,6.37,3.46,8.46,7.74,16.72,15.69,25,23.58,4.46,4.22,4.61,9,.32,13.51q-22,23.33-44.1,46.56-29.58,31.2-59.23,62.34a13.63,13.63,0,0,1-5.27,3.36c-12.92,4.39-25.92,8.59-38.88,12.87-2.48.82-4.9,1.43-7.08-.65s-1.71-4.5-1-7c3.54-13.39,7-26.8,10.59-40.17a10.24,10.24,0,0,1,2.35-4.22Q52.68,72,92,30.52c8.41-8.9,16.86-17.76,25.23-26.69,1.91-2,4-3.28,6.9-3.11Zm-70,132.42L129,53.88l-23.49-22.2L31.09,110.35ZM147.76,34,124.29,11.79,112.76,24l23.49,22.2C140.15,42.05,143.81,38.17,147.76,34ZM23.37,117.85a31.09,31.09,0,0,0-2.51,4.93c-1.43,4.81-2.29,9.83-4,14.51s-.88,8.16,3.27,11.1c1.48,1.05,2.5,1.61,4.33,1,5.83-2.06,11.77-3.82,17.6-5.89a36.52,36.52,0,0,0,5.39-3Z"
          />
        </g>
      </g>
    </svg>
  );
};

const iconRestore = (setClass, setAria) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 219.49 219.46"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Restore Icon</title>
      <desc id="desc">{setAria}</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path
              className="cls-1"
              d="M80.43,73.11V58.6h-9c-2.73,0-5.46,0-8.19,0-1.9,0-3.55-.35-4.38-2.22s-.06-3.34,1.25-4.74Q76.29,34.34,92.39,17q7-7.5,13.93-15c2.42-2.6,4.47-2.59,6.91.05l45.12,48.58c.48.53,1,1.07,1.45,1.59A3.75,3.75,0,0,1,157,58.6H139.13V73.11h2.3c13.65,0,27.3,0,40.95,0a12.23,12.23,0,0,1,9.74,4.41Q205,92.14,218,106.64a6.33,6.33,0,0,1,1.44,4.67q0,33.54,0,67.09c0,7.54.06,15.08,0,22.62a18.06,18.06,0,0,1-14.7,18.08,20.89,20.89,0,0,1-4.26.35q-90.78,0-181.56,0c-9.46,0-16.58-5.66-18.52-14.64A21.8,21.8,0,0,1,0,200.15q0-44.46,0-88.92A7.3,7.3,0,0,1,2,106Q14.76,91.87,27.3,77.58a12.4,12.4,0,0,1,9.91-4.49c13.58.06,27.17,0,40.75,0ZM212,113.64a5.85,5.85,0,0,0-.77-.16q-23.21,0-46.41,0c-2.43,0-3.72,1.34-3.82,3.76-.09,2.21,0,4.42,0,6.63-.12,10.82-7.62,18.71-18.44,18.79q-32.76.24-65.52,0c-9.29,0-16.47-6-18.09-14.9-.57-3.09-.3-6.34-.35-9.52-.06-3.62-1.18-4.78-4.81-4.78H9.48c-.62,0-1.25.08-1.95.12,0,.67-.08,1.18-.08,1.69q0,42.8,0,85.6c0,6.78,4.58,11.18,11.53,11.18H200.52a13.77,13.77,0,0,0,3.28-.29,10.64,10.64,0,0,0,8.26-10.68q0-43,0-86C212.07,114.64,212,114.2,212,113.64Zm-124.11-.45h43.76V56.55c0-.52,0-1,0-1.56a3.64,3.64,0,0,1,3.85-3.75c3.71,0,7.41,0,11.12,0,.6,0,1.21-.06,2.14-.12l-39-42L70.64,51.23H83c3.71,0,4.88,1.16,4.88,4.87q0,27.3,0,54.6ZM11.94,106h2.81c13.13,0,26.26,0,39.39,0,5.65,0,9.82,2.88,11.24,7.84a21.38,21.38,0,0,1,.56,4.81c.12,2.66-.18,5.37.25,8,.91,5.35,5.47,8.62,11.57,8.62h64c.65,0,1.3,0,1.95-.08A10.65,10.65,0,0,0,153.52,125c.08-2.14,0-4.29,0-6.43,0-8.09,4.42-12.49,12.56-12.49h38.81c.72,0,1.45-.06,2.49-.11l-1.27-1.47c-6.43-7.25-12.89-14.46-19.27-21.75A5.92,5.92,0,0,0,182,80.45c-13.65.06-27.3,0-40.95,0-.63,0-1.26.06-2,.09v35.58c0,3.37-1.18,4.55-4.58,4.55H85.09c-3.41,0-4.58-1.18-4.58-4.54V80.48c-14.91,0-29.53,0-44.15.06a4.36,4.36,0,0,0-2.89,1.31C26.38,89.7,19.38,97.64,11.94,106Z"
            />
            <path
              className="cls-1"
              d="M109.79,149.94c9.75,0,19.5,0,29.25,0A11,11,0,0,1,142,171.51a15,15,0,0,1-3.85.44q-28.38,0-56.75,0c-4.59,0-8.27-1.68-10.5-5.8A11,11,0,0,1,80.53,150C90.28,149.92,100,149.94,109.79,149.94Zm0,7.37H89.3c-2.92,0-5.84,0-8.76,0a3.5,3.5,0,0,0-3.61,3.55,3.45,3.45,0,0,0,3.49,3.63c.58.05,1.17,0,1.75,0h55.15a17,17,0,0,0,2.14-.07,3.43,3.43,0,0,0,3.12-3.77c-.11-2.09-1.67-3.38-4.17-3.38Z"
            />
            <path
              className="cls-1"
              d="M205.05,187a74.51,74.51,0,0,1-.52,9.11,10.62,10.62,0,0,1-10.48,8.73c-4.8.07-9.61,0-14.42,0-2.48,0-4.06-1.55-4-3.77s1.58-3.58,4.17-3.59c4.41,0,8.83,0,13.24,0,3.14,0,4.51-1.39,4.52-4.52,0-4.42,0-8.84,0-13.25,0-2.59,1.35-4.13,3.58-4.16s3.75,1.58,3.78,4.22c0,2.41,0,4.81,0,7.21Z"
            />
            <path className="cls-1" d="M33.46,91.71H67.93v7.2H33.46Z" />
            <path className="cls-1" d="M150.39,98.86V91.75h34.53v7.11Z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

const iconHeart = (setClass, setAria, fillColor) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Heart Icon</title>
      <desc id="desc">{setAria}</desc>
      <path
        d="M11.7859 1.125C9.24991 1.125 7.99991 3.625 7.99991 3.625C7.99991 3.625 6.74991 1.125 4.21397 1.125C2.15304 1.125 0.521005 2.84922 0.499911 4.90664C0.456942 9.17734 3.8878 12.2145 7.64835 14.7668C7.75203 14.8373 7.87452 14.8751 7.99991 14.8751C8.12531 14.8751 8.2478 14.8373 8.35148 14.7668C12.1116 12.2145 15.5425 9.17734 15.4999 4.90664C15.4788 2.84922 13.8468 1.125 11.7859 1.125V1.125Z"
        fill={fillColor}
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const iconCardCalendar = (setClass, setAria) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Calendar Icon</title>
      <desc id="desc">{setAria}</desc>
      <path
        d="M3.15391 2.5H13.6667C14.5376 2.5 15.2437 3.17157 15.2437 4V13C15.2437 13.8284 14.5376 14.5 13.6667 14.5H3.15391C2.283 14.5 1.57699 13.8284 1.57699 13V4C1.57699 3.17157 2.283 2.5 3.15391 2.5Z"
        stroke="#797979"
        strokeLinejoin="round"
      />
      <path
        d="M7.09618 8C6.66073 8 6.30772 7.66421 6.30772 7.25C6.30772 6.83579 6.66073 6.5 7.09618 6.5C7.53164 6.5 7.88464 6.83579 7.88464 7.25C7.88464 7.66421 7.53164 8 7.09618 8Z"
        fill="#797979"
      />
      <path
        d="M4.46801 8C4.03255 8 3.67955 7.66421 3.67955 7.25C3.67955 6.83579 4.03255 6.5 4.46801 6.5C4.90346 6.5 5.25647 6.83579 5.25647 7.25C5.25647 7.66421 4.90346 8 4.46801 8Z"
        fill="#797979"
      />
      <path
        d="M7.09618 10.5C6.66073 10.5 6.30772 10.1642 6.30772 9.75C6.30772 9.33579 6.66073 9 7.09618 9C7.53164 9 7.88464 9.33579 7.88464 9.75C7.88464 10.1642 7.53164 10.5 7.09618 10.5Z"
        fill="#797979"
      />
      <path
        d="M4.46801 10.5C4.03255 10.5 3.67955 10.1642 3.67955 9.75C3.67955 9.33579 4.03255 9 4.46801 9C4.90346 9 5.25647 9.33579 5.25647 9.75C5.25647 10.1642 4.90346 10.5 4.46801 10.5Z"
        fill="#797979"
      />
      <path
        d="M12.3527 10.5C11.9172 10.5 11.5642 10.1642 11.5642 9.75C11.5642 9.33579 11.9172 9 12.3527 9C12.7881 9 13.1411 9.33579 13.1411 9.75C13.1411 10.1642 12.7881 10.5 12.3527 10.5Z"
        fill="#797979"
      />
      <path
        d="M9.72436 10.5C9.2889 10.5 8.93589 10.1642 8.93589 9.75C8.93589 9.33579 9.2889 9 9.72436 9C10.1598 9 10.5128 9.33579 10.5128 9.75C10.5128 10.1642 10.1598 10.5 9.72436 10.5Z"
        fill="#797979"
      />
      <path
        d="M12.3527 13C11.9172 13 11.5642 12.6642 11.5642 12.25C11.5642 11.8358 11.9172 11.5 12.3527 11.5C12.7881 11.5 13.1411 11.8358 13.1411 12.25C13.1411 12.6642 12.7881 13 12.3527 13Z"
        fill="#797979"
      />
      <path
        d="M9.72436 13C9.2889 13 8.93589 12.6642 8.93589 12.25C8.93589 11.8358 9.2889 11.5 9.72436 11.5C10.1598 11.5 10.5128 11.8358 10.5128 12.25C10.5128 12.6642 10.1598 13 9.72436 13Z"
        fill="#797979"
      />
      <path
        d="M7.09618 13C6.66073 13 6.30772 12.6642 6.30772 12.25C6.30772 11.8358 6.66073 11.5 7.09618 11.5C7.53164 11.5 7.88464 11.8358 7.88464 12.25C7.88464 12.6642 7.53164 13 7.09618 13Z"
        fill="#797979"
      />
      <path d="M4.20522 1.5V2.5M12.6155 1.5V2.5V1.5Z" stroke="#797979" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.57699 5H15.2437" stroke="#797979" strokeLinejoin="round" />
    </svg>
  );
};

const iconLocationPin = (setClass, setAria) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Location Pin Icon</title>
      <desc id="desc">{setAria}</desc>
      <path
        d="M7.97015 1.5C5.49504 1.5 3.48694 3.41844 3.48694 5.78125C3.48694 8.5 6.47574 12.8084 7.5732 14.2966C7.61875 14.3594 7.67846 14.4105 7.74744 14.4457C7.81643 14.481 7.89274 14.4994 7.97015 14.4994C8.04755 14.4994 8.12387 14.481 8.19285 14.4457C8.26184 14.4105 8.32154 14.3594 8.3671 14.2966C9.46455 12.8091 12.4534 8.50219 12.4534 5.78125C12.4534 3.41844 10.4453 1.5 7.97015 1.5Z"
        stroke="#797979"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.97011 7.5C8.79545 7.5 9.46451 6.82843 9.46451 6C9.46451 5.17157 8.79545 4.5 7.97011 4.5C7.14478 4.5 6.47571 5.17157 6.47571 6C6.47571 6.82843 7.14478 7.5 7.97011 7.5Z"
        stroke="#797979"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const iconProgramType = (setClass, setAria) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Program Type Icon</title>
      <desc id="desc">{setAria}</desc>
      <path d="M8 12.5V14.5" stroke="#797979" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 6.5V8.5" stroke="#797979" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 1.5V2.5" stroke="#797979" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13 6.5H3.20719C3.14149 6.50001 3.07643 6.48707 3.01573 6.46192C2.95503 6.43678 2.89988 6.39991 2.85344 6.35344L1 4.5L2.85344 2.64656C2.89988 2.60009 2.95503 2.56322 3.01573 2.53808C3.07643 2.51293 3.14149 2.49999 3.20719 2.5H13C13.1326 2.5 13.2598 2.55268 13.3536 2.64645C13.4473 2.74021 13.5 2.86739 13.5 3V6C13.5 6.13261 13.4473 6.25979 13.3536 6.35355C13.2598 6.44732 13.1326 6.5 13 6.5Z"
        stroke="#797979"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12.5H12.7928C12.8585 12.5 12.9236 12.4871 12.9843 12.4619C13.045 12.4368 13.1001 12.3999 13.1466 12.3534L15 10.5L13.1466 8.64656C13.1001 8.60009 13.045 8.56322 12.9843 8.53808C12.9236 8.51293 12.8585 8.49999 12.7928 8.5H3C2.86739 8.5 2.74021 8.55268 2.64645 8.64645C2.55268 8.74021 2.5 8.86739 2.5 9V12C2.5 12.1326 2.55268 12.2598 2.64645 12.3536C2.74021 12.4473 2.86739 12.5 3 12.5Z"
        stroke="#797979"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const iconBack = (setClass, setAria) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
    >
      <desc id="desc">{setAria}</desc>
      <path d="M11.6897 15.75L7.96875 12L11.6897 8.25" stroke="#043544" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.48584 12H16.0313" stroke="#043544" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M21 12C21 7.03125 16.9688 3 12 3C7.03125 3 3 7.03125 3 12C3 16.9688 7.03125 21 12 21C16.9688 21 21 16.9688 21 12Z"
        stroke="#043544"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

const iconSearch = (setClass, setAria) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // className={setClass}
      aria-labelledby="title desc"
    >
      <title id="title">Search Icon</title>
      <desc id="desc">{setAria}</desc>
      <path
        d="M7.81226 2.33334C6.71437 2.33334 5.64114 2.66924 4.72828 3.29856C3.81541 3.92787 3.10392 4.82235 2.68378 5.86886C2.26364 6.91538 2.15371 8.06694 2.36789 9.17791C2.58208 10.2889 3.11077 11.3094 3.88709 12.1104C4.66342 12.9113 5.65252 13.4568 6.72931 13.6778C7.8061 13.8988 8.92223 13.7853 9.93655 13.3519C10.9509 12.9184 11.8178 12.1843 12.4278 11.2425C13.0377 10.3006 13.3633 9.19333 13.3633 8.06058C13.3632 6.54165 12.7783 5.08497 11.7373 4.01092C10.6963 2.93688 9.28446 2.33344 7.81226 2.33334V2.33334Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M11.9539 12.3335L15.8306 16.3333"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

const iconOpenLinkInNewWindow = (setClass, setAria) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
    >
      <path
        d="M9.70515 0H6.88187C6.74147 0 6.60683 0.0557723 6.50755 0.155048C6.40827 0.254323 6.3525 0.388969 6.3525 0.529366C6.3525 0.669763 6.40827 0.804409 6.50755 0.903684C6.60683 1.00296 6.74147 1.05873 6.88187 1.05873H8.42715L3.35276 6.13312C3.25393 6.23249 3.19854 6.367 3.19873 6.50714C3.19892 6.64729 3.25468 6.78164 3.35378 6.88074C3.45288 6.97984 3.58723 7.0356 3.72738 7.03579C3.86752 7.03598 4.00203 6.98059 4.1014 6.88176L9.17579 1.80737V3.35265C9.17579 3.49305 9.23156 3.62769 9.33084 3.72697C9.43011 3.82625 9.56476 3.88202 9.70515 3.88202C9.84555 3.88202 9.9802 3.82625 10.0795 3.72697C10.1787 3.62769 10.2345 3.49305 10.2345 3.35265V0.529366C10.2345 0.388969 10.1787 0.254323 10.0795 0.155048C9.9802 0.0557723 9.84555 0 9.70515 0Z"
        fill="black"
      />
      <path
        d="M9.70504 4.94075C9.56465 4.94075 9.43 4.99652 9.33072 5.0958C9.23145 5.19507 9.17568 5.32972 9.17568 5.47011V9.17568H1.05873V1.05873H4.76429C4.90469 1.05873 5.03934 1.00296 5.13861 0.903684C5.23789 0.804409 5.29366 0.669763 5.29366 0.529366C5.29366 0.388969 5.23789 0.254323 5.13861 0.155048C5.03934 0.0557723 4.90469 0 4.76429 0H0.529366C0.388969 0 0.254323 0.0557723 0.155048 0.155048C0.0557723 0.254323 0 0.388969 0 0.529366V9.70504C0 9.84544 0.0557723 9.98009 0.155048 10.0794C0.254323 10.1786 0.388969 10.2344 0.529366 10.2344H9.70504C9.84544 10.2344 9.98009 10.1786 10.0794 10.0794C10.1786 9.98009 10.2344 9.84544 10.2344 9.70504V5.47011C10.2344 5.32972 10.1786 5.19507 10.0794 5.0958C9.98009 4.99652 9.84544 4.94075 9.70504 4.94075Z"
        fill="black"
      />
    </svg>
  );
};

const iconLightbulb = (setClass, setAria) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // className={setClass}
      aria-labelledby="title desc"
    >
      <path
        d="M14.25 18V16.875C14.25 15.5156 15.7284 14.2299 16.6875 13.3125C18.0393 12.0202 18.75 10.2839 18.75 8.25003C18.75 4.50003 15.7626 1.50003 12 1.50003C11.1128 1.49755 10.234 1.67046 9.41393 2.0088C8.59386 2.34714 7.84877 2.84425 7.22148 3.47154C6.59419 4.09883 6.09708 4.84392 5.75874 5.66399C5.4204 6.48405 5.24749 7.36291 5.24997 8.25003C5.24997 10.2113 5.99106 12.0652 7.31247 13.3125C8.26637 14.213 9.74997 15.5016 9.74997 16.875V18"
        stroke="#043544"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.5 22.5H13.5" stroke="#043544" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.75 20.25H14.25" stroke="#043544" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 18V12" stroke="#043544" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.7812 11.25C13.7812 11.25 12.773 12 12 12C11.227 12 10.2188 11.25 10.2188 11.25"
        stroke="#043544"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const iconPlus = (setClass, setAria) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="plusIconTitle plusIconDesc"
      style={{ transform: 'rotate(45deg)' }}
      role="img"
    >
      <title id="plusIconTitle">Plus Icon</title>
      <desc id="plusIconDesc">{setAria}</desc>
      <path d="M9.06071 8.00008L12.0295 5.03133C12.1704 4.89068 12.2496 4.69982 12.2498 4.50074C12.25 4.30166 12.171 4.11066 12.0304 3.96977C11.8897 3.82887 11.6989 3.74962 11.4998 3.74944C11.3007 3.74927 11.1097 3.82818 10.9688 3.96883L8.00008 6.93758L5.03133 3.96883C4.89043 3.82793 4.69934 3.74878 4.50008 3.74878C4.30082 3.74878 4.10973 3.82793 3.96883 3.96883C3.82793 4.10973 3.74878 4.30082 3.74878 4.50008C3.74878 4.69934 3.82793 4.89043 3.96883 5.03133L6.93758 8.00008L3.96883 10.9688C3.82793 11.1097 3.74878 11.3008 3.74878 11.5001C3.74878 11.6993 3.82793 11.8904 3.96883 12.0313C4.10973 12.1722 4.30082 12.2514 4.50008 12.2514C4.69934 12.2514 4.89043 12.1722 5.03133 12.0313L8.00008 9.06258L10.9688 12.0313C11.1097 12.1722 11.3008 12.2514 11.5001 12.2514C11.6993 12.2514 11.8904 12.1722 12.0313 12.0313C12.1722 11.8904 12.2514 11.6993 12.2514 11.5001C12.2514 11.3008 12.1722 11.1097 12.0313 10.9688L9.06071 8.00008Z" />
    </svg>
  );
};

const iconLock = (setClass, setAria) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby="title desc"
      role="img"
    >
      <title id="title">Locked Icon</title>
      <desc id="desc">{setAria}</desc>
      <g>
        <path
          d="M12.8562 16H3.8562C3.02953 16 2.3562 15.3273 2.3562 14.5V7.5C2.3562 6.67267 3.02953 6 3.8562 6H12.8562C13.6829 6 14.3562 6.67267 14.3562 7.5V14.5C14.3562 15.3273 13.6829 16 12.8562 16ZM3.8562 7C3.58087 7 3.3562 7.224 3.3562 7.5V14.5C3.3562 14.776 3.58087 15 3.8562 15H12.8562C13.1315 15 13.3562 14.776 13.3562 14.5V7.5C13.3562 7.224 13.1315 7 12.8562 7H3.8562Z"
          fill="black"
        />
        <path
          d="M11.8562 7C11.5802 7 11.3562 6.776 11.3562 6.5V4C11.3562 2.346 10.0102 1 8.3562 1C6.7022 1 5.3562 2.346 5.3562 4V6.5C5.3562 6.776 5.1322 7 4.8562 7C4.5802 7 4.3562 6.776 4.3562 6.5V4C4.3562 1.794 6.1502 0 8.3562 0C10.5622 0 12.3562 1.794 12.3562 4V6.5C12.3562 6.776 12.1322 7 11.8562 7Z"
          fill="black"
        />
        <path
          d="M8.35628 11.3334C7.62095 11.3334 7.02295 10.7354 7.02295 10.0001C7.02295 9.26475 7.62095 8.66675 8.35628 8.66675C9.09161 8.66675 9.68961 9.26475 9.68961 10.0001C9.68961 10.7354 9.09161 11.3334 8.35628 11.3334ZM8.35628 9.66675C8.17295 9.66675 8.02295 9.81608 8.02295 10.0001C8.02295 10.1841 8.17295 10.3334 8.35628 10.3334C8.53961 10.3334 8.68961 10.1841 8.68961 10.0001C8.68961 9.81608 8.53961 9.66675 8.35628 9.66675Z"
          fill="black"
        />
        <path
          d="M8.3562 13.3333C8.0802 13.3333 7.8562 13.1093 7.8562 12.8333V11C7.8562 10.724 8.0802 10.5 8.3562 10.5C8.6322 10.5 8.8562 10.724 8.8562 11V12.8333C8.8562 13.1093 8.6322 13.3333 8.3562 13.3333Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

const iconChevronDown = (setClass, setAria) => {

  let uniqID = generateUniqueId(); 
  let titleId = "downChevronTitle-" + uniqID; 
  let descId = "downChevronDesc-" + uniqID; 
 
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={setClass}
      aria-labelledby={`${titleId} ${descId}`}
      role="img"
    >
      <title id={titleId}>Down Chevron Icon</title>
      <desc id={descId}>{setAria}</desc>
      <path
        d="M3.5 5.75L8 10.25L12.5 5.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const iconChevronLeft = (setClass, setAria) => {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title desc"
      className={setClass}
    >
      <desc id="desc">{setAria}</desc>
      <path
        d="M5.25 1.5L0.75 6L5.25 10.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const iconCircleInfo = (setClass, setAria) => {
  const strokeColor = '#767676';
  const fillColor = '#767676';

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={setClass}>
      <desc id="circleInfo">{setAria}</desc>
      <path
        d="M8.06171 2.08032C4.75875 2.08032 2.08057 4.75851 2.08057 8.06147C2.08057 11.3644 4.75875 14.0426 8.06171 14.0426C11.3647 14.0426 14.0429 11.3644 14.0429 8.06147C14.0429 4.75851 11.3647 2.08032 8.06171 2.08032Z"
        stroke={strokeColor}
        strokeWidth="1.0402"
        strokeMiterlimit="10"
      />
      <path
        d="M7.15137 7.15137H8.19157V10.9221"
        stroke={strokeColor}
        strokeWidth="1.0402"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.76123 11.052H9.62178"
        stroke={strokeColor}
        strokeWidth="1.0402"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.06147 4.22583C7.89431 4.22583 7.73091 4.2754 7.59192 4.36827C7.45294 4.46113 7.34461 4.59313 7.28064 4.74756C7.21667 4.902 7.19994 5.07193 7.23255 5.23587C7.26516 5.39982 7.34565 5.55041 7.46385 5.66861C7.58205 5.78681 7.73264 5.8673 7.89659 5.89991C8.06053 5.93252 8.23047 5.91579 8.3849 5.85182C8.53933 5.78785 8.67133 5.67952 8.7642 5.54054C8.85707 5.40155 8.90663 5.23815 8.90663 5.07099C8.90663 4.84684 8.81759 4.63187 8.65909 4.47337C8.50059 4.31487 8.28562 4.22583 8.06147 4.22583Z"
        fill={fillColor}
      />
    </svg>
  );
};

const iconSuccessMountain = (setClass, setAria) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      // className={setClass}
      aria-labelledby="title desc"
      role="img"
      viewBox="0 0 200 200"
      // style="enable-background:new 0 0 200 200;"
    >
      {/* <style type="text/css">
	.st0{fill:#010101;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#17748A;}
	.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#A2D9E7;}
	.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#5DBB5A;}
	.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#28783C;}
	.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#0F485D;}
	.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#52A2B9;}
	.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#11485D;}
	.st8{fill:#F06089;}
	.st9{fill:#050606;}
</style> */}
      <title id="title">Via Icon - Success </title>
      <desc id="desc">{setAria}</desc>
      <g>
        <path
          className="st0"
          d="M100,4c52.9,0,96,43.1,96,96s-43.1,96-96,96S4,152.9,4,100S47.1,4,100,4 M100,0C44.8,0,0,44.8,0,100
		s44.8,100,100,100s100-44.8,100-100S155.2,0,100,0L100,0z"
        />
      </g>
      <g>
        <g>
          <path
            className="st1"
            d="M102.5,79.9c7.5,12.9,14.9,25.9,22.4,38.8l24.1,41.7H52.7l24.1-41.7c4.8-8.3,9.6-16.6,14.4-24.9
			c0.9-1.5,6.3-2.1,6.3-2.1s-1.8-5.7-0.9-7.3c0.9-1.5,1.7-3,2.6-4.5C100.1,78.3,101.6,78.3,102.5,79.9L102.5,79.9z"
          />
          <path
            className="st2"
            d="M86.6,101.7l11.9,8.4c1.7,1.1,3.2,1.1,4.8,0l11.9-8.4c-4.2-7.3-8.4-14.5-12.6-21.8c-1-1.6-2.4-1.6-3.4,0
			C95,87.2,90.8,94.4,86.6,101.7L86.6,101.7z"
          />
          <path
            className="st1"
            d="M161.9,156.9c1,1.8,0,3.6-2.1,3.6h-44c-2,0-3.1-1.8-2.1-3.5l11-19.1l12.1-20.9c0.5-0.9,1.4-1,2,0
			C146.5,130.2,154.2,143.5,161.9,156.9L161.9,156.9z"
          />
          <path
            className="st1"
            d="M57.6,128.9c5.4,9.3,10.8,18.6,16.1,27.9c1,1.8,0,3.5-2.1,3.5H41.5c-2.1,0-3.1-1.8-2.1-3.6
			c5.4-9.3,10.7-18.6,16.1-27.9C56.1,128,57,128,57.6,128.9z"
          />
          <path
            className="st3"
            d="M153.4,67.4h-32.5c-1.1-0.2-2-1-2.1-2.1v-17h34.6c0.6,0,0.8,0.4,0.5,1l-6.4,8.6l6.4,8.6
			C154.2,66.8,154,67.4,153.4,67.4z"
          />
          <path className="st4" d="M118.8,62.3v-14h22.3V58c-0.3,2.2-2,3.9-4.2,4.2L118.8,62.3L118.8,62.3z" />
          <path
            className="st3"
            d="M134.6,57.9h-33.5c-1.1-0.2-2-1-2.1-2.1V40.8c0.2-1.1,1-2,2.1-2.1h33.5c1.1,0.2,2,1,2.1,2.1v14.9
			C136.6,56.8,135.7,57.7,134.6,57.9L134.6,57.9z"
          />
          <path
            className="st2"
            d="M128.4,131.5l7.7,5.4c1.2,0.8,2.4,0.8,3.5,0l7.7-5.4c-2.8-4.9-5.6-9.7-8.4-14.6c-0.6-1-1.4-0.9-2,0
			C134,121.7,131.2,126.6,128.4,131.5L128.4,131.5z"
          />
          <path
            className="st2"
            d="M49.8,139l5.6,3.9c0.8,0.6,1.7,0.6,2.5,0l5.6-3.9c-1.9-3.4-3.9-6.7-5.8-10.1c-0.6-1-1.4-0.9-2,0
			C53.7,132.3,51.7,135.7,49.8,139z"
          />
          <path className="st5" d="M118.8,118.7l8.5,14.7l1.1-1.9l2-3.4l-5.4-9.4l-9.8-17l-4.3,3.1L118.8,118.7z" />
          <path
            className="st6"
            d="M102.4,90.3l8.3,14.5l4.3-3.1l-12.4-21.5l-0.2-0.3c-0.5-0.8-1.1-1.2-1.7-1.2c-0.6,0-1.2,0.4-1.7,1.2L99,80.2
			l-1.2,2.1l1.2,2.1l1.8,3.2L102.4,90.3z"
          />
          <path
            className="st5"
            d="M142.9,134.5c4.3,7.4,8.6,14.9,12.9,22.3c1,1.8,0,3.6-2.1,3.6h6.1c2.1,0,3.1-1.8,2.1-3.6
			c-4.9-8.5-9.8-16.9-14.7-25.4L142.9,134.5z"
          />
          <path
            className="st6"
            d="M134.8,120.4c2.7,4.7,5.4,9.4,8.1,14.1l4.3-3.1c-2.8-4.9-5.6-9.7-8.4-14.6c0,0,0,0,0,0c-0.6-1-1.4-0.9-2,0
			L134.8,120.4z"
          />
          <path
            className="st7"
            d="M61.2,145.7l6.4,11.1c1,1.8,0,3.5-2.1,3.5h6.1c2.1,0,3.1-1.8,2.1-3.5l-9.5-16.4l-0.8-1.4l-4.3,3.1L61.2,145.7
			z"
          />
          <path className="st6" d="M53.5,132.5l5.5,9.6l4.3-3.1l-5.8-10.1c-0.6-1-1.4-0.9-2,0L53.5,132.5z" />
        </g>
        <path
          className="st0"
          d="M61.2,138.4l-4.4-7.5l-4.4,7.5l4.4,3.1L61.2,138.4z M110.7,158.5c5.9-10.1,11.7-20.3,17.6-30.4l-13.7-23.7
		l-12.5,8.9c-0.6,0.5-1.5,0.5-2.2,0l-12.6-8.9c-6.9,12-13.9,24-20.8,36c3.5,6,7,12.1,10.5,18.1L110.7,158.5z M72.7,158.5
		c-3.2-5.6-6.5-11.2-9.7-16.8l-5.1,3.6c-0.6,0.5-1.5,0.5-2.2,0l-5.1-3.6c-3.2,5.6-6.5,11.2-9.7,16.8L72.7,158.5z M160.8,158.5
		c-4.7-8.1-9.4-16.3-14.1-24.4l-7.7,5.5c-0.6,0.5-1.5,0.5-2.2,0l-7.8-5.5c-4.7,8.1-9.4,16.3-14.1,24.4L160.8,158.5z M55.2,126.3
		c0.5-0.9,1.6-1.2,2.5-0.7c0.3,0.2,0.5,0.4,0.7,0.7l6,10.4C73,121.9,81.5,107,90.1,92.2c0.5-0.9,1.6-1.2,2.5-0.7
		c0.9,0.5,1.2,1.6,0.7,2.5l-4.1,7.1l11.8,8.3l11.8-8.3L101,80.7l-3.4,5.8c-0.5,0.9-1.6,1.2-2.5,0.7c-0.9-0.5-1.2-1.6-0.7-2.5
		l4.7-8.1V58V38.9c0-1,0.8-1.8,1.8-1.8h35.8c1,0,1.8,0.8,1.8,1.8v7.7h16c1,0,1.8,0.8,1.8,1.8c0,0.5-0.2,0.9-0.5,1.2l-6.3,8.3
		l6.4,8.4c0.6,0.8,0.4,2-0.4,2.6c-0.3,0.2-0.7,0.4-1.1,0.4h-35.8c-1,0-1.8-0.8-1.8-1.8v-7.7h-14.2v16.8
		c9.2,15.9,18.4,31.9,27.6,47.8l5.9-10.1c0.5-0.9,1.6-1.2,2.5-0.7c0.3,0.2,0.5,0.4,0.7,0.7c8.7,15,17.4,30.1,26.1,45.2
		c0.5,0.9,0.2,2-0.7,2.5c-0.3,0.2-0.6,0.3-0.9,0.3c-42.1,0-84.2,0-126.3,0c-1,0-1.8-0.8-1.8-1.8c0-0.4,0.1-0.7,0.3-1
		C42.5,148.3,48.8,137.3,55.2,126.3L55.2,126.3z M130.9,130.9l7,4.9l7-4.9l-7-12.1C135.6,122.9,133.2,126.9,130.9,130.9z
		 M120.7,59.8v5.8H151l-4.9-6.6c-0.5-0.6-0.5-1.6,0-2.2l5-6.6h-12.4V58c0,1-0.8,1.8-1.8,1.8H120.7z M102.8,56.1h16.1h16V40.7h-32.1
		V56.1z"
        />
      </g>
      <g>
        <g>
          <g>
            <path
              className="st8"
              d="M65.7,86.7c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.8-0.4-1-0.8l-5.7-11.5l-5.1,4.1l0.2,3.3c0,0.5-0.2,1-0.5,1.3
				l-3.1,2.6c-0.3,0.2-0.6,0.4-1,0.4c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.9-0.6-1-1.1l-1.4-5.4l-5.1-2.3c-0.5-0.2-0.8-0.7-0.9-1.2
				c-0.1-0.5,0.1-1,0.5-1.4L44,72c0.3-0.2,0.6-0.4,1-0.4c0.1,0,0.2,0,0.4,0l3.2,0.8l4.9-4.3l-10.3-7.6c-0.4-0.3-0.6-0.7-0.6-1.2
				c0-0.5,0.2-0.9,0.5-1.2l3.4-2.9c0.3-0.2,0.6-0.4,1-0.4c0.2,0,0.4,0,0.6,0.1L61.7,61l6-5.2c0.8-0.7,1.8-1.1,2.9-1.1
				c1.3,0,2.5,0.6,3.4,1.6c0.8,0.9,1.1,2.1,1,3.3c-0.1,1.2-0.7,2.2-1.6,3l-6.2,5L70.6,82c0.1,0.6-0.1,1.1-0.5,1.5l-3.4,2.9
				C66.4,86.6,66,86.7,65.7,86.7z"
            />
            <path
              className="st9"
              d="M70.6,56.2c0.8,0,1.6,0.4,2.2,1c1,1.2,0.9,3.1-0.4,4.1L65.5,67l3.6,15.4l-3.4,2.9l-6.6-13.1L52,77.8l0.3,4.1
				l-3.1,2.6l-1.6-6.1l-5.8-2.6l3.1-2.6l4,1l6.9-6l-11.8-8.8l3.4-2.9L62,62.8l6.7-5.8C69.2,56.5,69.9,56.2,70.6,56.2 M70.6,53.2
				c-1.4,0-2.8,0.5-3.9,1.5l-5.3,4.6l-12.8-5.5c-0.4-0.2-0.8-0.2-1.2-0.2c-0.7,0-1.4,0.2-1.9,0.7l-3.4,2.9c-0.7,0.6-1.1,1.5-1.1,2.4
				c0,0.9,0.5,1.8,1.2,2.3l8.8,6.5l-2.9,2.5l-2.5-0.6c-0.2-0.1-0.5-0.1-0.7-0.1c-0.7,0-1.4,0.2-1.9,0.7L40,73.5
				c-0.8,0.7-1.2,1.7-1,2.7c0.1,1,0.8,1.9,1.7,2.3l4.4,2l1.2,4.7c0.3,1,1,1.8,2,2.1c0.3,0.1,0.6,0.1,0.9,0.1c0.7,0,1.4-0.2,1.9-0.7
				l3.1-2.6c0.7-0.6,1.1-1.6,1.1-2.5l-0.2-2.5l3-2.4l4.9,9.8c0.4,0.8,1.2,1.4,2.1,1.6c0.2,0,0.4,0.1,0.6,0.1c0.7,0,1.4-0.2,1.9-0.7
				l3.4-2.9c0.9-0.7,1.3-1.9,1-3l-3.2-13.5l5.4-4.4c1.2-1,2-2.4,2.2-4c0.2-1.6-0.3-3.1-1.4-4.4C74,54,72.3,53.2,70.6,53.2L70.6,53.2
				z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const iconConversation = (setClass, setAria) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title desc"
      className={setClass}
    >
      <desc id="circleInfo">{setAria}</desc>
      <g clipPath="url(#clip0)">
        <path
          d="M11.4636 10.1147C11.2911 10.1147 11.1511 10.2547 11.1511 10.4272V12.5835C11.1511 13.4451 10.4502 14.146 9.58862 14.146H6.21462C6.04209 14.146 5.90225 14.2858 5.90212 14.4583L5.90169 15.0796L5.15581 14.3337C5.10753 14.2229 4.99703 14.146 4.86922 14.146H2.83862C1.97706 14.146 1.27612 13.4451 1.27612 12.5835V7.771C1.27612 6.90943 1.97706 6.2085 2.83862 6.2085H5.99487C6.16744 6.2085 6.30737 6.06859 6.30737 5.896C6.30737 5.7234 6.16744 5.5835 5.99487 5.5835H2.83862C1.63244 5.5835 0.651123 6.56481 0.651123 7.771V12.5835C0.651123 13.7897 1.63244 14.771 2.83862 14.771H4.70919L5.99265 16.0545C6.05244 16.1142 6.13234 16.146 6.21369 16.146C6.2539 16.146 6.2945 16.1382 6.33309 16.1222C6.44987 16.0739 6.52603 15.9601 6.52612 15.8337L6.52687 14.771H9.58862C10.7948 14.771 11.7761 13.7897 11.7761 12.5835V10.4272C11.7761 10.2547 11.6362 10.1147 11.4636 10.1147Z"
          fill="#043544"
        />
        <path
          d="M12.1091 0.145996H11.3182C8.81369 0.145996 6.77612 2.18356 6.77612 4.68806C6.77612 7.19256 8.81369 9.23009 11.3182 9.23009H12.1091C12.5 9.23009 12.8869 9.18043 13.2619 9.08231L14.4302 10.25C14.49 10.3097 14.5699 10.3415 14.6512 10.3415C14.6915 10.3415 14.7321 10.3337 14.7707 10.3177C14.8875 10.2693 14.9636 10.1553 14.9636 10.029V8.22096C15.4583 7.82037 15.8692 7.31434 16.1576 6.74903C16.4851 6.10696 16.6511 5.41356 16.6511 4.68806C16.6511 2.18356 14.6136 0.145996 12.1091 0.145996ZM14.4631 7.81896C14.3847 7.878 14.3386 7.97043 14.3386 8.06859V9.27484L13.5739 8.51053C13.5144 8.45109 13.4346 8.41906 13.353 8.41906C13.3223 8.41906 13.2914 8.42359 13.2612 8.43287C12.8892 8.54718 12.5016 8.60512 12.1091 8.60512H11.3182C9.15828 8.60512 7.40112 6.84793 7.40112 4.68806C7.40112 2.52818 9.15831 0.770996 11.3182 0.770996H12.1091C14.269 0.770996 16.0261 2.52818 16.0261 4.68806C16.0261 5.92965 15.4564 7.07084 14.4631 7.81896Z"
          fill="#043544"
        />
        <path
          d="M13.1209 3.56538C13.0758 2.91116 12.5484 2.38379 11.8942 2.33869C11.5233 2.31323 11.1693 2.43832 10.8984 2.69123C10.6312 2.94063 10.478 3.29319 10.478 3.65854C10.478 3.83113 10.618 3.97104 10.7905 3.97104C10.9631 3.97104 11.103 3.83113 11.103 3.65854C11.103 3.46294 11.1818 3.28166 11.3249 3.14813C11.4678 3.01473 11.6547 2.94869 11.8512 2.96226C12.1958 2.98601 12.4736 3.26379 12.4974 3.60838C12.5214 3.95641 12.293 4.26398 11.9545 4.33973C11.6802 4.4011 11.4886 4.63948 11.4886 4.91938V5.67016C11.4886 5.84276 11.6285 5.98266 11.8011 5.98266C11.9737 5.98266 12.1136 5.84276 12.1136 5.67016V4.94435C12.7432 4.79223 13.1657 4.21604 13.1209 3.56538Z"
          fill="#043544"
        />
        <path
          d="M12.022 6.68531C11.9638 6.62719 11.8832 6.59375 11.801 6.59375C11.7188 6.59375 11.6382 6.62719 11.5801 6.68531C11.522 6.74344 11.4885 6.82406 11.4885 6.90625C11.4885 6.98875 11.522 7.06938 11.5801 7.1275C11.6382 7.18563 11.7188 7.21875 11.801 7.21875C11.8832 7.21875 11.9638 7.18563 12.022 7.1275C12.0801 7.06906 12.1135 6.98875 12.1135 6.90625C12.1135 6.82406 12.0801 6.74344 12.022 6.68531Z"
          fill="#043544"
        />
        <path
          d="M9.24487 9.8335H2.65112C2.47856 9.8335 2.33862 9.9734 2.33862 10.146C2.33862 10.3186 2.47856 10.4585 2.65112 10.4585H9.24487C9.41747 10.4585 9.55737 10.3186 9.55737 10.146C9.55737 9.9734 9.41744 9.8335 9.24487 9.8335Z"
          fill="#043544"
        />
        <path
          d="M9.46578 11.6751C9.40769 11.6169 9.32706 11.5835 9.24487 11.5835C9.16269 11.5835 9.08206 11.6169 9.02394 11.6751C8.96578 11.7332 8.93237 11.8138 8.93237 11.896C8.93237 11.9782 8.96581 12.0588 9.02394 12.1169C9.08206 12.1751 9.16269 12.2085 9.24487 12.2085C9.32706 12.2085 9.40769 12.1751 9.46578 12.1169C9.52394 12.0588 9.55737 11.9785 9.55737 11.896C9.55737 11.8138 9.5239 11.7332 9.46578 11.6751Z"
          fill="#043544"
        />
        <path
          d="M8.01572 11.5835H2.65112C2.47856 11.5835 2.33862 11.7234 2.33862 11.896C2.33862 12.0686 2.47856 12.2085 2.65112 12.2085H8.01572C8.18831 12.2085 8.32822 12.0686 8.32822 11.896C8.32822 11.7234 8.18828 11.5835 8.01572 11.5835Z"
          fill="#043544"
        />
        <path
          d="M7.21362 8.0835H2.65112C2.47856 8.0835 2.33862 8.2234 2.33862 8.396C2.33862 8.56859 2.47856 8.7085 2.65112 8.7085H7.21362C7.38622 8.7085 7.52612 8.56859 7.52612 8.396C7.52612 8.2234 7.38619 8.0835 7.21362 8.0835Z"
          fill="#043544"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" transform="translate(0.651123 0.145996)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const iconCheckMarkSolid = (setClass, setAria) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={setClass}>
      <title id="title">Checkmark Solid</title>
      <desc id="desc">{setAria}</desc>
      <path
        d="M10.4629 0.836914C5.0868 0.836914 0.712891 5.21082 0.712891 10.5869C0.712891 15.963 5.0868 20.3369 10.4629 20.3369C15.839 20.3369 20.2129 15.963 20.2129 10.5869C20.2129 5.21082 15.839 0.836914 10.4629 0.836914ZM15.5371 7.31926L9.23711 14.8193C9.168 14.9016 9.08201 14.9681 8.98496 15.0142C8.88791 15.0604 8.78207 15.0852 8.67461 15.0869H8.66195C8.55683 15.0869 8.45289 15.0647 8.35687 15.0219C8.26086 14.9791 8.17491 14.9166 8.10461 14.8385L5.40461 11.8385C5.33604 11.7657 5.2827 11.68 5.24772 11.5864C5.21275 11.4928 5.19684 11.3931 5.20094 11.2932C5.20504 11.1933 5.22906 11.0953 5.27159 11.0048C5.31413 10.9144 5.37431 10.8333 5.44861 10.7665C5.52291 10.6996 5.60983 10.6483 5.70425 10.6155C5.79868 10.5827 5.8987 10.5691 5.99845 10.5755C6.0982 10.5819 6.19566 10.6082 6.28511 10.6528C6.37455 10.6975 6.45418 10.7595 6.5193 10.8354L8.64227 13.1941L14.3887 6.35457C14.5176 6.20554 14.6999 6.11323 14.8963 6.09758C15.0928 6.08193 15.2874 6.1442 15.4383 6.27093C15.5892 6.39766 15.6841 6.57867 15.7026 6.77484C15.7211 6.97101 15.6616 7.16657 15.5371 7.31926Z"
        fill="#2A8A53"
      />
    </svg>
  );
};

export {
  iconEye,
  iconSolo,
  iconGroup,
  iconAddActivity,
  iconAddHousing,
  iconAddTransportation,
  iconTableView,
  iconRosterView,
  iconMap,
  iconTrash,
  iconCheckMark,
  iconCheckMarkSolid,
  iconWarning,
  iconItinerary,
  iconCalendar,
  iconMapMagnifying,
  iconSuitcase,
  iconGear,
  iconClock,
  iconClockPicker,
  iconPencil,
  iconRestore,
  iconHeart,
  iconCardCalendar,
  iconLocationPin,
  iconProgramType,
  iconBack,
  iconSearch,
  iconOpenLinkInNewWindow,
  iconLightbulb,
  iconPlus,
  iconLock,
  iconChevronDown,
  iconSuccessMountain,
  iconCircleInfo,
  iconChevronLeft,
  iconConversation,
};
